<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">聚宝盆</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>抵押贷款列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select
          v-model="form.mortgageCoinType"
          placeholder="请选择抵押币种"
          @change="handleSearch"
        >
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in coinTypeList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-select
          v-model="form.borrowCoinType"
          placeholder="请选择所借币种"
          @change="handleSearch"
        >
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in coinTypeList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-select
          v-model="form.status"
          placeholder="订单状态"
          @change="handleSearch"
        >
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input placeholder="请输入用户ID" v-model="form.userId"></el-input>
        <el-input placeholder="周期" v-model="form.stage"></el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import moment from 'moment';

export default {
  name: 'mortgagerecord',
  data() {
    return {
      form: {},
      types: [
        { value: '1', label: '借贷中' },
        { value: '2', label: '已到期' },
        { value: '3', label: '已逾期' },
        { value: '4', label: '违约还款' },
        { value: '5', label: '逾期还款' },
        { value: '11', label: '已还款' },
        { value: '12', label: '爆仓' }
      ]
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState('mortgagerecord', ['pagination', 'coinTypeList'])
  },
  methods: {
    ...mapActions('mortgagerecord', ['getRecords', 'getCoinTypeList']),
    handleSearch() {
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      this.getRecords({
        ...this.form,
        ...this.pagination,
        ...data
      });
    }
  },
  mounted() {
    this.getList();
    this.getCoinTypeList();
  }
};
</script>
